import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { ILabTestCategory } from 'app/shared/model/lab-test-category.model';
import { ILabTestItem } from 'app/shared/model/lab-test-item.model';
import { ILabPrescription } from 'app/shared/model/lab-prescription.model';
import { IAntibiotic } from 'app/shared/model/antibiotic.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';

export interface IUserLabTestItem {
  id?: string;
  active?: boolean;
  lastupdated?: number;
  microSec?: number;
  result?: string | null;
  timestampentry?: number;
  observation?: string | null;
  cursor?: number;
  instructions?: string | null;
  readingType?: string | null;
  patientType?: keyof typeof PatientType | null;
  exposed?: boolean | null;
  limits?: string | null;
  statusCode?: string | null;
  groupPanelId?: string | null;
  glucoUser?: IGlucoUser;
  category?: ILabTestCategory;
  item?: ILabTestItem;
  labPres?: ILabPrescription | null;
  recommendedAntibiotic?: IAntibiotic | null;
}

export const defaultValue: Readonly<IUserLabTestItem> = {
  active: false,
  exposed: false,
};
